import { Language } from '@shared/enums/language.enum';
import { Cliente } from './cliente.model';
import { Sociedad } from './sociedad.model';

export interface ICredenciales {
  email: string;
  password: string;
}

export class Credenciales implements ICredenciales {
  email: string;
  password: string;

  constructor({ email, password }: ICredenciales) {
    this.email = email || '';
    this.password = password || '';
  }
}

export interface Perfil {
  idPerfil: number;
  descripcion: string;
}

export interface MenuData {
  id: number;
  orden: number;
}

export interface MenuItem {
  title: string;
  link: string | null;
  icon: string;
  group: boolean;
  data: MenuData;
  children?: MenuItem[];
}

export interface MenuUsuarioData {
  id: string | null;
  path: string | null;
}

export interface MenuUsuarioItem {
  title: string;
  icon: string | null;
  data: MenuUsuarioData;
  children?: MenuUsuarioItem[];
}

export interface ObjetoUsuario {
  token: string;
  refresh_token: string;
  idUsuario: number;
  apellidoYNombre: string;
  perfil: Perfil;
  siglaIdioma: string;
  menu: MenuItem[];
  menuUsuario: MenuUsuarioItem[];
  lstSociedades: Sociedad[];
  lstClientes: Cliente[];
  lstPosiblesBases: DataBase[];
}

export interface DataBase {
  idBase: number;
  descripcion: string;
  imagenPath: string;
}

export type UsuarioAuthenticado = Pick<ObjetoUsuario, 'token' | 'refresh_token' | 'siglaIdioma' | 'idUsuario' | 'apellidoYNombre' | 'perfil' | 'lstPosiblesBases'>;

export type DbData = Pick<ObjetoUsuario, 'token' | 'refresh_token' | 'siglaIdioma' | 'idUsuario' | 'apellidoYNombre' | 'perfil'>;

export interface LoginResponse {
  user: UsuarioAuthenticado;
  mensaje: string;
}

export interface DBResponse {
  user: UsuarioDB;
}

export type UsuarioDB = Pick<ObjetoUsuario, 'menu' | 'menuUsuario' | 'lstClientes' | 'lstSociedades' | 'token' | 'refresh_token'>;

export type RefreshTokenResponse = Pick<ObjetoUsuario, 'token' | 'refresh_token'>;

export type IStoredUser = Pick<ObjetoUsuario, 'perfil' | 'idUsuario' | 'apellidoYNombre'>;

export class StoredUser implements IStoredUser {
  idUsuario: number;
  apellidoYNombre: string;
  perfil: Perfil;

  constructor({ idUsuario, apellidoYNombre, perfil }: IStoredUser) {
    this.idUsuario = idUsuario;
    this.apellidoYNombre = apellidoYNombre;
    this.perfil = perfil;
  }
}

export interface TokenData {
  nameid: number;
  unique_name: string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/locality': Language;
  email: string;
  nbf: number;
  exp: number;
  iat: number;
}

export type PassRecover = Pick<TokenData, 'email'>;

export type Message = Pick<LoginResponse, 'mensaje'>;
